import { DateTime } from 'luxon';

// Checks if format resolves to valid DateTime
// returns an ISODate
export function parseDateString(string) {
  if (string) {
    let date = DateTime.fromISO(string);
    if (!date.isValid) {
      date = DateTime.fromRFC2822(string);
    }
    if (!date.isValid) {
      date = DateTime.fromHTTP(string);
    }
    if (!date.isValid) {
      date = DateTime.fromJSDate(new Date(string));
    }
    return date.isValid ? date.toISODate() : undefined;
  }
  return undefined;
}

export function getEnvFromHostname(hostname) {
  const regex = /^signin-([^.]+)\.quickencs\.com/;
  const match = regex.exec(hostname);
  if (match && match.length === 2) {
    return match[1];
  }
  return 'prod';
}

export function getClientTypeFromClientId(clientId) {
  const regex = /^quicken(?:_.+)?_(.+)/;
  const match = regex.exec(clientId);
  if (match && match.length === 2) {
    return match[1];
  }
  return 'unknown';
}

export function checkForQueryFlag(query, flag) {
  let result = false;
  if (query[flag] !== undefined) {
    result = query[flag] !== null ? query[flag] : true;
  }
  return result;
}

// utility function to simple copy an object
export function copyObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function noNaN(n) {
  return parseFloat(n) ? n : 0;
}
//-------------------------------------------------------
// Normalize amount to 2 digits (cents)

export function normalizeAmt(amt, sign = 1) {
  return parseFloat((parseFloat(amt) * sign).toFixed(2)).toString();
}

export function addEventListenerOnce(element, event, fn) {
  const func = () => {
    element.removeEventListener(event, func);
    fn();
  };
  element.addEventListener(event, func);
}

export function filterByKeys(obj, filterFn) {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (filterFn(obj[key])) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}

export function mapJSObject(obj, fn) {
  const ret = {};
  Object.keys(obj).forEach((key) => {
    ret[key] = fn(obj[key]);
  });
  return ret;
}

export function findInObject(obj, compareFn) {
  const matches = [];
  Object.keys(obj).forEach((key) => {
    if (compareFn(obj[key], key)) {
      matches.push(obj[key]);
    }
  });
  return matches;
}

export function reduceObjectToArray(obj, filterFn) {
  const newArray = [];
  Object.keys(obj).forEach((key) => {
    newArray.push(filterFn(obj[key]));
  });
  return newArray;
}

export function exists(v) {
  return v !== undefined && v !== null;
}

export function isMac() {
  return navigator.userAgent.indexOf('Mac') > -1;
}

// ask for 'safari', 'firefox', 'edge', or 'opera'
export function isBrowser(type) {
  const browserMap = {};
  browserMap.chrome = navigator.userAgent.indexOf('Chrome') > -1;
  browserMap.firefox = navigator.userAgent.indexOf('Firefox') > -1;
  browserMap.safari = navigator.userAgent.indexOf('Safari') > -1;
  browserMap.opera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
  if (browserMap.chrome && browserMap.safari) {
    browserMap.safari = false;
  }
  if (browserMap.chrome && browserMap.opera) {
    browserMap.chrome = false;
  }

  return browserMap[type.toLowerCase()];
}

export function safeRefIn(obj, refs) {
  if (obj && refs) {
    if (refs.length === 0) {
      return obj;
    }
    return safeRefIn(obj[refs[0]], refs.slice(1));
  }
  return null;
}

export function listSize(list) {
  if (list.size !== undefined) return list.size;
  return list.length;
}

export function replaceRawASCII(string) {
  return string?.replace(/&#(.*?);/g, (code) => {
    let num = code.replace(/&#|x|;/g, '');
    num = parseInt(num, code[2] === 'x' ? 16 : 10);
    return String.fromCharCode(num);
  });
}

export function treatEnterAsTab(e) {
  if (e.key === 'Enter') {
    e.stopPropagation();
    const focusable = Array.from(
      document.querySelectorAll(
        'a[href], area[href], button, input, textarea, select, details, object, embed, *[contenteditable], *[tabindex]',
      ),
    ).filter(
      (el) =>
        !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && Number(el.getAttribute('tabindex')) !== -1,
    );
    let currentIndex = focusable.findIndex((item) => item === e.currentTarget);
    if (currentIndex === -1) {
      // default to e.target if currentTarget is not found
      currentIndex = focusable.findIndex((item) => item === e.target);
    }
    if (currentIndex !== -1) {
      const next = focusable[currentIndex + 1];
      if (next) {
        // need to focus in a timeout to prevent the 'enter' keyDown from applying to the new focus field
        // I know, it's weird, but since react 17, state updates/dom interaction can complete before an event finishes bubbling/triggering
        setTimeout(() => next.focus(), 0);
      }
    }
  }
}
